import * as React from 'react';
import { Helmet } from 'react-helmet';

const npmTitle = process.env.REACT_APP_NAME;
const npmDescription = process.env.REACT_APP_DESCRIPTION;
const npmKeywords = process.env.REACT_APP_KEYWORDS;

interface HeadProps {
    title?: string;
    description?: string;
    keywords?: string;
}

export const Head: React.FC<HeadProps> = ({
    title = npmTitle,
    description = npmDescription,
    keywords = npmKeywords,
}) => (
    <Helmet>
        <html lang="en" />
        <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="rgb(27, 185, 199)" />
        <link rel="icon" href="/favicon.png" />
        <link rel="shortcut icon" href="/favicon.png" />
        <link rel="apple-touch-icon" href="/logo.png" />

        <title lang="en">{title}</title>
    </Helmet>
);
